const rangeInputs = document.querySelectorAll('input[type="range"]');

// Attach the "change" event listener to each input element
rangeInputs.forEach(function (input) {
	input.addEventListener('input', function () {
		const val =
			(this.value - this.getAttribute('min')) /
			(this.getAttribute('max') - this.getAttribute('min'));
		// Create the gradient string
		const gradient = `-webkit-gradient(linear, left top, right top, color-stop(${val}, #676775), color-stop(${val}, #e6e6ed))`;

		// Apply the gradient as the background image
		this.style.backgroundImage = gradient;
	});
});
